import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "options-wrapper"
};
const _hoisted_2 = {
  class: "filter-list"
};
const _hoisted_3 = {
  key: 0,
  class: "ideology-wrapper"
};
const _hoisted_4 = {
  class: "line-title"
};
const _hoisted_5 = {
  class: "ideology-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "two-child-list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "third-child-list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "pop-box"
};
const _hoisted_14 = {
  class: "pop-title"
};
const _hoisted_15 = {
  class: "pop-list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "tag-list"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  key: 1,
  class: "college-wrapper"
};
const _hoisted_20 = {
  class: "line-title"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "pop-box"
};
const _hoisted_23 = {
  key: 0,
  class: "college-children"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 2,
  class: "college-wrapper"
};
const _hoisted_26 = {
  class: "line-title"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "pop-box"
};
const _hoisted_29 = {
  key: 0,
  class: "college-children"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  key: 3,
  class: "college-wrapper"
};
const _hoisted_32 = {
  class: "line-title"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  class: "pop-box"
};
const _hoisted_35 = {
  key: 0,
  class: "college-children"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  class: "result-wrapper"
};
const _hoisted_38 = {
  class: "result-box"
};
const _hoisted_39 = {
  class: "result-title"
};
const _hoisted_40 = {
  key: 0,
  class: "filter"
};
const _hoisted_41 = {
  key: 1,
  class: "filter"
};
const _hoisted_42 = {
  key: 2,
  class: "filter"
};
const _hoisted_43 = {
  key: 3,
  class: "filter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_arrow_right = _resolveComponent("arrow-right");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_close = _resolveComponent("close");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.activeTab == 1 && _ctx.filterArr.indexOf('1') > -1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[4] || (_cache[4] = _createElementVNode("span", {
    class: "title"
  }, "思政元素", -1)), _createElementVNode("span", {
    class: "right",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.isshowAllIde = !_ctx.isshowAllIde)
  }, _toDisplayString(_ctx.isshowAllIde ? '收起' : '查看全部>'), 1)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showIdeologyList, ({
    id,
    ideologyName,
    children
  }, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: id
    }, [_createVNode(_component_el_popover, {
      placement: "right-start",
      width: 275,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(["ideology-item", id == _ctx.curIdeolog.id ? 'active' : '']),
        onClick: _withModifiers($event => _ctx.chooseIdeolog(id, ideologyName), ["stop"])
      }, [_createElementVNode("div", {
        style: _normalizeStyle({
          backgroundColor: _ctx.formatColor(index)
        }),
        class: "ideology-item-title"
      }, _toDisplayString(ideologyName), 5), children && children.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [children.length > 1 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(children.slice(0, 3), ({
        id,
        ideologyName,
        children
      }) => {
        return _openBlock(), _createElementBlock("div", {
          class: "two-child-item",
          key: ideologyName
        }, [_createElementVNode("span", {
          class: _normalizeClass(["label", id == _ctx.curIdeolog.id ? 'active' : '']),
          onClick: _withModifiers($event => _ctx.chooseIdeolog(id, ideologyName), ["stop"])
        }, _toDisplayString(ideologyName), 11, _hoisted_8), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, ({
          id,
          ideologyName
        }) => {
          return _openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["third-child-item", id == _ctx.curIdeolog.id ? 'active' : '']),
            onClick: _withModifiers($event => _ctx.chooseIdeolog(id, ideologyName), ["stop"]),
            key: id
          }, _toDisplayString(ideologyName), 11, _hoisted_9);
        }), 128))]);
      }), 128)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [(_openBlock(), _createElementBlock("div", {
        class: "two-child-item",
        key: ideologyName
      }, [_createElementVNode("span", {
        class: _normalizeClass(["label", id == _ctx.curIdeolog.id ? 'active' : '']),
        onClick: _withModifiers($event => _ctx.chooseIdeolog(children[0].id, children[0].ideologyName), ["stop"])
      }, _toDisplayString(children[0].ideologyName), 11, _hoisted_10)])), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children[0].children, ({
        id,
        ideologyName
      }) => {
        return _openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["third-child-item", id == _ctx.curIdeolog.id ? 'active' : '']),
          onClick: _withModifiers($event => _ctx.chooseIdeolog(id, ideologyName), ["stop"]),
          key: id
        }, _toDisplayString(ideologyName), 11, _hoisted_12);
      }), 128))])], 64))])) : _createCommentVNode("", true)], 10, _hoisted_6)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(ideologyName), 1), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, ({
        id,
        ideologyName,
        children
      }) => {
        return _openBlock(), _createElementBlock("div", {
          class: "ido-item",
          key: id
        }, [_createElementVNode("div", {
          class: _normalizeClass(["tag-title", id == _ctx.curIdeolog.id ? 'active' : '']),
          onClick: _withModifiers($event => _ctx.chooseIdeolog(id, ideologyName), ["stop"])
        }, _toDisplayString(ideologyName), 11, _hoisted_16), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, ({
          id,
          ideologyName
        }) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tag-item", id == _ctx.curIdeolog.id ? 'active' : '']),
            onClick: _withModifiers($event => _ctx.chooseIdeolog(id, ideologyName), ["stop"]),
            key: ideologyName
          }, _toDisplayString(ideologyName), 11, _hoisted_18);
        }), 128))])]);
      }), 128))])])]),
      _: 2
    }, 1024)]);
  }), 128))])])) : _createCommentVNode("", true), _ctx.activeTab == 1 && _ctx.filterArr.indexOf('2') > -1 || _ctx.activeTab == 2 && _ctx.filterArr.indexOf('1') > -1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[5] || (_cache[5] = _createElementVNode("span", {
    class: "title"
  }, "所属机构", -1)), _createElementVNode("span", {
    class: "right",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.isShowAllCollege = !_ctx.isShowAllCollege)
  }, _toDisplayString(_ctx.isShowAllCollege ? '收起' : '查看全部>'), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["college-list", _ctx.isShowAllCollege ? 'showAll' : ''])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collegeList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["college-item", _ctx.curCollege.id == item.id ? 'active' : '']),
      onClick: _withModifiers($event => _ctx.chooseCollege(item.id, item.organName), ["stop"]),
      key: index
    }, [_createVNode(_component_el_popover, {
      placement: "bottom-start",
      offset: 0,
      disabled: !item.children || !item.children.length,
      width: 600,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(item.organName), 1)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [item.children && item.children.length ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, ({
        id,
        organName
      }) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["college-children-item", _ctx.curCollege.id == id ? 'active' : '']),
          onClick: _withModifiers($event => _ctx.chooseCollege(id, organName), ["stop"]),
          key: id
        }, _toDisplayString(organName), 11, _hoisted_24);
      }), 128))])) : _createCommentVNode("", true)])]),
      _: 2
    }, 1032, ["disabled"])], 10, _hoisted_21);
  }), 128))], 2)])) : _createCommentVNode("", true), _ctx.filterArr.indexOf('3') > -1 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_cache[6] || (_cache[6] = _createElementVNode("span", {
    class: "title"
  }, "适用专业", -1)), _createElementVNode("span", {
    class: "right",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.isShowAllMajor = !_ctx.isShowAllMajor)
  }, _toDisplayString(_ctx.isShowAllMajor ? '收起' : '查看全部>'), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["college-list", _ctx.isShowAllMajor ? 'showAll' : ''])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.majorList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["college-item", _ctx.curMajor.id == item.id ? 'active' : '']),
      onClick: _withModifiers($event => _ctx.chooseMajor(item.id, item.organName, item.id), ["stop"]),
      key: index
    }, [_createVNode(_component_el_popover, {
      placement: "bottom-start",
      offset: 0,
      disabled: !item.children || !item.children.length,
      width: 600,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(item.organName), 1)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [item.children && item.children.length ? (_openBlock(), _createElementBlock("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, ({
        id,
        organName
      }) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["college-children-item", _ctx.curMajor.id == id ? 'active' : '']),
          onClick: _withModifiers($event => _ctx.chooseMajor(id, organName, item.id), ["stop"]),
          key: id
        }, _toDisplayString(organName), 11, _hoisted_30);
      }), 128))])) : _createCommentVNode("", true)])]),
      _: 2
    }, 1032, ["disabled"])], 10, _hoisted_27);
  }), 128))], 2)])) : _createCommentVNode("", true), _ctx.activeTab == 2 && _ctx.filterArr.indexOf('2') > -1 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_cache[7] || (_cache[7] = _createElementVNode("span", {
    class: "title"
  }, "课程类型", -1)), _createElementVNode("span", {
    class: "right",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.isShowAllType = !_ctx.isShowAllType)
  }, _toDisplayString(_ctx.isShowAllType ? '收起' : '查看全部>'), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["college-list", _ctx.isShowAllType ? 'showAll' : ''])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseTypeList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["college-item", _ctx.curType.id == item.id ? 'active' : '']),
      onClick: _withModifiers($event => _ctx.chooseType(item.id, item.dict_name), ["stop"]),
      key: index
    }, [_createVNode(_component_el_popover, {
      placement: "bottom-start",
      offset: 0,
      disabled: !item.children || !item.children.length,
      width: 600,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(item.dict_name), 1)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [item.children && item.children.length ? (_openBlock(), _createElementBlock("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, ({
        id,
        dict_name
      }) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["college-children-item", _ctx.curType.id == id ? 'active' : '']),
          onClick: _withModifiers($event => _ctx.chooseType(id, dict_name), ["stop"]),
          key: id
        }, _toDisplayString(dict_name), 11, _hoisted_36);
      }), 128))])) : _createCommentVNode("", true)])]),
      _: 2
    }, 1032, ["disabled"])], 10, _hoisted_33);
  }), 128))], 2)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[8] || (_cache[8] = _createTextVNode(" 找到约 ")), _createElementVNode("span", null, _toDisplayString(_ctx.total), 1), _cache[9] || (_cache[9] = _createTextVNode(" 条相关结果： "))]), _ctx.curIdeolog.id ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_cache[10] || (_cache[10] = _createTextVNode(" 思政元素 ")), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_arrow_right)]),
    _: 1
  }), _createElementVNode("span", null, _toDisplayString(_ctx.curIdeolog.ideologyName), 1), _createVNode(_component_el_icon, {
    class: "icon-close",
    onClick: _ctx.delIdeolog
  }, {
    default: _withCtx(() => [_createVNode(_component_close)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _ctx.curCollege.id && _ctx.curCollege.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_cache[11] || (_cache[11] = _createTextVNode(" 所属机构 ")), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_arrow_right)]),
    _: 1
  }), _createElementVNode("span", null, _toDisplayString(_ctx.curCollege.organName), 1), _createVNode(_component_el_icon, {
    class: "icon-close",
    onClick: _ctx.delCollege
  }, {
    default: _withCtx(() => [_createVNode(_component_close)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _ctx.curMajor.id && _ctx.curMajor.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[12] || (_cache[12] = _createTextVNode(" 适用专业 ")), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_arrow_right)]),
    _: 1
  }), _createElementVNode("span", null, _toDisplayString(_ctx.curMajor.majorName), 1), _createVNode(_component_el_icon, {
    class: "icon-close",
    onClick: _ctx.delMajor
  }, {
    default: _withCtx(() => [_createVNode(_component_close)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _ctx.curType.id && _ctx.curType.id > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_cache[13] || (_cache[13] = _createTextVNode(" 课程类型 ")), _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_arrow_right)]),
    _: 1
  }), _createElementVNode("span", null, _toDisplayString(_ctx.curType.dict_name), 1), _createVNode(_component_el_icon, {
    class: "icon-close",
    onClick: _ctx.delType
  }, {
    default: _withCtx(() => [_createVNode(_component_close)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)])])]);
}